import type { ElementType } from 'react';

import { S } from './Card.styles';
import type { CardProps } from './Card.types';
import { CardContext } from './CardContext';

export const Card = <C extends ElementType = 'div'>({
  component,
  fullHeight,
  isInteractive,
  ...otherProps
}: CardProps<C>) => (
  <CardContext.Provider value={{ fullHeight }}>
    <S.Container as={component} $fullHeight={fullHeight} $isInteractive={isInteractive} {...otherProps} />
  </CardContext.Provider>
);
